import React from 'react';
import ReactDOM from 'react-dom';

import Cookie from '@wetransfer/concorde-cookie';

import Actions from '@app/action';
import Config from '@app/config';
import Store from '@app/store';

import I18n from '@module/i18n';
import Analytics from '@module/analytics';
import Router from '@module/router';

import StaticPage from '@component/panel/content';
import PlusCustomisation from '@app/page/plus/customisation';
import FeatureFlagsHelper from '@app/helper/featureflags';

let pageLoad = true;
let context;

const renderCustomisation = (container) => {
  const { session } = Store.getState();
  const previews = Config.curatedPreviews.desktop;
  const startingIndex = Math.floor(Math.random() * Math.floor(previews.length));
  const customisation = (
    <PlusCustomisation
      previews={previews}
      mobilePreview={Config.curatedPreviews.mobile}
      start={startingIndex}
      domain={session.domain}
    />
  );

  ReactDOM.render(customisation, container);
};

const contentElementClickHandler = () => {
  Analytics.trackStructEvent({
    category: 'plus_page',
    action: 'click_sign_up',
  });
};

const pricingFormat = (pricing) => {
  const currency = I18n.t(`number.currency.${pricing.currency.toUpperCase()}`);
  const price = I18n.number(pricing.total, { precision: 2 });
  return [currency, price];
};

export const plusPage = (instance) => {
  // We want to be updated with store updates
  instance.subscribeToStore = true;

  const { route, ui, pending, session } = Store.getState();

  if (route.query.coupon) {
    const url = new URL(location.href);
    Router.navigateTo('/sign-up', true, {
      search: url.searchParams.toString(),
    });
    return;
  }

  if (ui && ui.subscriptionPricing) {
    const checklistTitle = instance.node.querySelector(
      '.plus__checklist-title'
    );
    if (checklistTitle) {
      const [currency, price] = pricingFormat(ui.subscriptionPricing.month);
      checklistTitle.innerText = I18n.t('page.about_plus.checklist.title', {
        price,
        currency,
      });
    }
  }

  // We request the subscription pricing in order to show pricing
  // information on the plus page.
  if (!ui.subscriptionPricing && !pending.getSubscriptionPricing) {
    Store.dispatch(
      Actions.UI.getSubscriptionPricing({
        country_code: session.region.country || '',
        vat_number: '',
        coupon_code: '',
        plan_tier: '',
      })
    );
  }

  // Get our DOM elements
  const pixelTrackerElements = instance.node.querySelectorAll(
    '[data-pixel-tracker]'
  );

  const signupButtons = instance.node.querySelectorAll('.button__signup');
  const customisationElement = instance.node.querySelector(
    '#plus-new__customisation'
  );

  if (context !== route.context) {
    pageLoad = true;
  }
  context = route.context;

  // Only once during page load.
  if (pageLoad) {
    pageLoad = false;

    Analytics.pushDataLayerEvent({
      category: 'Plus',
      action: 'Signup Form View',
      channel: Cookie.get('wt_trk') || undefined,
    });

    Analytics.trackStructEvent({
      category: 'plus',
      action: 'show_sign_up',
    });

    signupButtons.forEach(function(button) {
      button.addEventListener('click', contentElementClickHandler);
    });

    pixelTrackerElements.forEach((tracker) => {
      tracker.addEventListener('click', () => {
        Analytics.loadTrackingPixel(tracker.dataset.pixelTracker);
      });
    });
  }

  // Render customisation on new plus page
  if (FeatureFlagsHelper.unlimitedTransfers && customisationElement) {
    renderCustomisation(customisationElement);
  }

  const signupLinks = instance.node.querySelectorAll('.button__signup');
  const signupHref = new URL(location);
  signupHref.pathname = 'sign-up';
  signupLinks.forEach((link) => {
    link.href = signupHref;
  });

  // When we navigate away from the page, cleanup listeners
  instance.onCleanup = () => {
    signupButtons.forEach((button) => {
      button.removeEventListener('click', contentElementClickHandler);
    });

    if (FeatureFlagsHelper.unlimitedTransfers) {
      ReactDOM.unmountComponentAtNode(customisationElement);
    }
    pageLoad = true;

    pixelTrackerElements.forEach((tracker) => {
      tracker.removeEventListener('click', Analytics.loadTrackingPixel);
    });
  };
};

StaticPage.configure('/plus', plusPage);
